<template>
  <div class="text-center">
    <v-card class="pa-3 my-5 zoom" @click="overlay = !overlay">
      <v-list-item>
        <v-list-item-avatar>
          <v-img :src="imageUrl" />
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="headline">{{title}}</v-list-item-title>
          <v-list-item-subtitle>{{description}}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-card>

    <v-overlay :value="overlay" :dark="false" :opacity="0.8">
      <div class="white--text animated fadeInDown mb-8 title">
        <h1>{{title}}</h1>
        <p>{{description}}</p>
      </div>

      <v-row>
        <v-col>
          <v-card
            class="big pa-4 animated fadeInRight"
            style="overflow-y: scroll; height:70vh; min-width:50vw;"
          >
            <slot>
              <h1>Fill in with detailed info</h1>
            </slot>

            <KeyTechnologiesComponent 
            v-if="technologyUsed != null" class="mt-8" :used="technologyUsed" />
          </v-card>
        </v-col>
        <v-col class="animated fadeInLeft">
          <v-img class="big rounded" :src="imageUrl"></v-img>
          <div class="mt-8">
            <h3 class="grey--text mt-2">{{yearFromTo}}</h3>
            <h2 class="white--text">{{amountOfMonths}}</h2>
          </div>
        </v-col>
      </v-row>
      <v-btn class="animated fadeInUp" @click="overlay = false">Lukk</v-btn>
    </v-overlay>
  </div>
</template>

<script>
import KeyTechnologiesComponent from "@/components/KeyTechnologiesComponent";
export default {
  components: { KeyTechnologiesComponent },

  props: [
    "imageUrl",
    "title",
    "description",
    "technologyUsed",
    "amountOfMonths",
    "yearFromTo"
  ],
  data: () => ({
    overlay: false
  })
};
</script>

<style scoped>
.big {
  width: 25rem;
  min-height: 25rem;
}

div.title {
  border-radius: 25px;
  background-color: black;
  padding-top: 5px;
}

.rounded {
  border-radius: 25px;
}
</style>